import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

// services/kategoriService.js
export const fetchKategori = async (params = {}) => {
  try {
    const defaultParams = {
      page: 1,
      per_page: 10,
      disable_pagination: false,
      ...params
    };

    const queryParams = new URLSearchParams();
    
    Object.entries(defaultParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });

    const response = await axios.get(`${BASE_URL_BE}/kategori?${queryParams.toString()}`, {
      headers: getAuthHeaders()
    });
    
    return {
      success: true,
      data: response.data.data,
      meta: response.data.meta || {}
    };
  } catch (error) {
    console.error("Error fetching kategori:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Gagal memuat data kategori",
      error: error.response?.data || error.message
    };
  }
};

export const fetchKategoriPaket = async (params = {}) => {
  try {
    // Pastikan params.page dan params.per_page diubah ke string jika perlu
    const queryString = new URLSearchParams();
    
    if (params.page) queryString.append('page', params.page.toString());
    if (params.per_page) queryString.append('per_page', params.per_page.toString());
    if (params.disable_pagination) queryString.append('disable_pagination', 'true');
    
    const response = await axios.get(`${BASE_URL_BE}/kategori?${queryString.toString()}` , { 
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching kategori:', error);
    throw error;
  }
};

export const createKategori = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/kategori`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating paket:", error);
    throw error;
  }
};

export const updateKategori = async (id_paket, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/kategori/${id_paket}`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating kategori:", error);
    throw error;
  }
};

export const deleteKategori = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/kategori/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting paket:", error);
    throw error;
  }
};

export const listKategori = async () => {
  try {
    // Buat objek URLSearchParams
    const params = new URLSearchParams();
    params.append('disable_pagination', 'true'); // Tambahkan parameter disable_pagination

    // Bangun URL dengan parameter
    const response = await axios.get(`${BASE_URL_BE}/kategori?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching kategori:", error);
    throw error;
  }
};